import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

interface IEditPromptsBannerProps {
    onClick: () => void;
    isDisabled: boolean;
}

export const EditPromptsBanner = ({ onClick, isDisabled }: IEditPromptsBannerProps) => (
    <Flex
        data-automation="llm-setup-edit-prompts-banner"
        flexDirection="column"
        background={colorsPalettes.carbon[25]}
        padding="16px"
        gap="12px"
        borderRadius="6px"
    >
        <Text
            fontVariant="body1"
            color={colorsPalettes.carbon[400]}
        >
            {translate("llm.setup.edit-prompts.text")}
        </Text>
        <Box>
            <Button
                data-automation="llm-setup-edit-prompts-button"
                type="outlined"
                isDisabled={isDisabled}
                onClick={onClick}
            >
                {translate("llm.setup.edit-prompts.button")}
            </Button>
        </Box>
    </Flex>
);
